import { AbstractControl, ValidationErrors } from '@angular/forms';

export function alphabetsOnlyValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value;
	if (!value) return null;
	const regex = /^[a-zA-Z ]+$/;
	return regex.test(value) ? null : { alphabetsOnly: true };
}

export function alphaNumericValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value;
	if (!value) return null;
	const regex = /^[a-zA-Z0-9 ]+$/;
	return regex.test(value) ? null : { alphaNumeric: true };
}

export function locationValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value?.trim().replace(/\s+/g, ' ');
	if (!value) return null;

	const regex = /^[a-zA-Z0-9, ]+$/;
	return regex.test(value) ? null : { invalidLocation: true };
}

export function linkedInValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value;
	if (!value) return null;

	const regex = /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/;
	return regex.test(value) ? null : { invalidLinkedIn: true };
}

export function githubValidator(control: AbstractControl): ValidationErrors | null {
	const value = control.value;
	if (!value) return null;

	const regex = /^(https?:\/\/)?(www\.)?github\.com\/[a-zA-Z0-9_-]+\/?$/;
	return regex.test(value) ? null : { invalidGithub: true };
}	